import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { getPhotoShootRankingData } from "actions";
import MUIDataTable from "mui-datatables";

const useStyles = makeStyles((theme) =>
  createStyles({
    volt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#fd5842",
      color: "#fff",
    },
    ampere: {
      paddingTop: theme.spacing(0.3),
      backgroundColor: "#4ba0c1",
      color: "#fff",
    },
    watt: {
      paddingTop: theme.spacing(0.5),
      backgroundColor: "#6eb26e",
      color: "#fff",
    },
    tableHead: {
      height: 48,
      backgroundColor: "#fafafa",
    },
    tableRow: {
      height: 32,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableRowNone: {
      height: 126,
    },
    tblHead: {
      textAlign: "center",
      fontSize: 14,
      fontWeight: 500,
    },
    tblHeadLeft: {
      textAlign: "left",
      fontSize: 14,
      fontWeight: 500,
    },
    tblDataCenter: {
      textAlign: "center",
    },
    tblDataLeft: {
      textAlign: "left",
    },
    customTitle: {
      fontSize: 16,
      color: "#000",
    },
  })
);

const PhotoShootRanking = ({
  photoShootRankingData,
  getPhotoShootRankingData,
  dateRange,
}) => {
  const classes = useStyles();
    const [initialDataCall, setInitialDataCall] = useState(true);

  useEffect(() => {
    if (
      dateRange && dateRange[0] !== null &&
      initialDataCall
    ) {
      getPhotoShootRankingData();
      setInitialDataCall(false);
    }
  }, [dateRange]);

  const columns = [
    {
      name: "順",
      options: {
        filter: false,
        customHeadRender: ({ index, ...column }) => (
          <th key={index} className={classes.tblHead}>
            順
          </th>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "プレイヤーID",
      options: {
        filter: false,
        customHeadRender: ({ index, ...column }) => (
          <th key={index} className={classes.tblHeadLeft}>
            プレイヤーID
          </th>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataLeft}>{value}</div>;
        },
      },
    },
    {
      name: "プレイヤー名",
      options: {
        filter: false,
        customHeadRender: ({ index, ...column }) => (
          <th key={index} className={classes.tblHead}>
            プレイヤー名
          </th>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
    {
      name: "撮影数",
      options: {
        filter: false,
        customHeadRender: ({ index, ...column }) => (
          <th key={index} className={classes.tblHead}>
            撮影数
          </th>
        ),
        customBodyRender: (value) => {
          return <div className={classes.tblDataCenter}>{value}</div>;
        },
      },
    },
  ];
  const options = {
    filterType: "checkbox",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    viewColumns: false,
    downloadOptions: {
      filename: "撮影ランキングデータ",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: "none",
    rowsPerPage: 100,
    textLabels: {
      body: {
        noMatch: "日時範囲を指定してGOボタンを押してください",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [10, 20, 50, 100],
  };
  return (
    <Grid container spacing={1}>
      <Grid item sm={12}>
        <MUIDataTable
          title={<span className={classes.customTitle}>撮影ランキング</span>}
          data={photoShootRankingData}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

PhotoShootRanking.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dateRange: state.page.dateRangePicTree,
  photoShootRankingData: state.pictree.photoShootRankingData,
});

const mapDispatchToProps = (dispatch) => ({
  getPhotoShootRankingData: (param) =>
    dispatch(getPhotoShootRankingData(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(PhotoShootRanking));
